import { 
    faEye, // OSINT
    faBug, // Pwn
    faGlobe, // Web
    faMicrochip, // Reverse Engineering
    faLock, // Crypto
    faMagnifyingGlass, // Forensics
    faQuestionCircle, // Misc
    faImage, // Steganography
    faMemory, // Binary Exploitation
    faNetworkWired, // Networking
    faCode, // Programming
    faGamepad, // Game Hacking
    faCrown // full pwn
} from '@fortawesome/free-solid-svg-icons';

export const categories = {
    "OSINT": {
        icon: faEye,
        color: "#4CAF50", // Green
        gradient: "linear-gradient(135deg, #43A047, #66BB6A)"
    },
    "Pwn": {
        icon: faBug,
        color: "#E91E63", // Pink
        gradient: "linear-gradient(135deg, #D81B60, #EC407A)"
    },
    "Web": {
        icon: faGlobe,
        color: "#2196F3", // Blue
        gradient: "linear-gradient(135deg, #1E88E5, #42A5F5)"
    },
    "Reverse Engineering": {
        icon: faMicrochip,
        color: "#9C27B0", // Purple
        gradient: "linear-gradient(135deg, #8E24AA, #AB47BC)"
    },
    "Crypto": {
        icon: faLock,
        color: "#FF9800", // Orange
        gradient: "linear-gradient(135deg, #F57C00, #FFB74D)"
    },
    "Forensics": {
        icon: faMagnifyingGlass,
        color: "#607D8B", // Blue Grey
        gradient: "linear-gradient(135deg, #546E7A, #78909C)"
    },
    "Misc": {
        icon: faQuestionCircle,
        color: "#795548", // Brown
        gradient: "linear-gradient(135deg, #6D4C41, #8D6E63)"
    },
    "Steganography": {
        icon: faImage,
        color: "#009688", // Teal
        gradient: "linear-gradient(135deg, #00796B, #26A69A)"
    },
    "Binary Exploitation": {
        icon: faMemory,
        color: "#F44336", // Red
        gradient: "linear-gradient(135deg, #E53935, #EF5350)"
    },
    "Networking": {
        icon: faNetworkWired,
        color: "#3F51B5", // Indigo
        gradient: "linear-gradient(135deg, #3949AB, #5C6BC0)"
    },
    "Programming": {
        icon: faCode,
        color: "#FFC107", // Amber
        gradient: "linear-gradient(135deg, #FFA000, #FFCA28)"
    },
    "Game Hacking": {
        icon: faGamepad,
        color: "#8BC34A", // Light Green
        gradient: "linear-gradient(135deg, #7CB342, #9CCC65)"
    },
    "Full Pwn": {
        icon: faCrown,
        color: "#FF1744", // Bright Red
        gradient: "linear-gradient(135deg, #FF1744, #FF5722, #FFD700)", // Red to Orange to Gold
        special: true,
        glow: "0 0 20px #FF1744, 0 0 40px #FF1744, 0 0 60px #FF1744"
    }
};